import { render, staticRenderFns } from "./system_remind.vue?vue&type=template&id=4c91eeb2&scoped=true"
import script from "./system_remind.vue?vue&type=script&lang=js"
export * from "./system_remind.vue?vue&type=script&lang=js"
import style0 from "./system_remind.vue?vue&type=style&index=0&id=4c91eeb2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91eeb2",
  null
  
)

export default component.exports